export default __webpack_public_path__ + "static/media/thumb.1183eb01.png";